import { ScreenCampaignType } from 'types/ScreenCampaignType';

export const intialDataForm: ScreenCampaignType = {
	firstTitleCampaign: '',
	secondTitleCampaign: '',
	mainImageCampaign: {
		id: '',
		urlImage: '',
		linkRedirect: '',
		labelImage: ''
	},
	carouselImagesCampaign: [],
	queryListProductsCampaign: '',
	secondMainImageCampaign: {
		id: '',
		urlImage: '',
		linkRedirect: '',
		labelImage: ''
	},
	secondQueryListProductsCampaign: '',
	brandsCarousel: {
		title: '',
		brands: []
	},
	thirdMainImageCampaign: {
		id: '',
		urlImage: '',
		linkRedirect: '',
		labelImage: ''
	},
	footer: {
		title: '',
		description: ''
	}
};
